import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import "./style.scss";

const CustomModal = ({
  open,
  onClose,
  title,
  children,
  dialogClassName = "",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className={`custom-modal ${dialogClassName}`}
    >
      <div className="custom-modal__content">
        <div className="custom-modal__header">
          <DialogTitle className="custom-modal__title">{title}</DialogTitle>
          <IconButton
            aria-label="close"
            onClick={onClose}
            className="custom-modal__close-button"
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent dividers className="custom-modal__body">
          {children}
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default CustomModal;
